import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import EstateSalesPage from "@/pages/EstateSalesPage";
import CleanoutsPage from "@/pages/CleanoutsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import MarylandPage from "@/pages/MarylandPage";
import NorthernVirginiaPage from "@/pages/NorthernVirginiaPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import UpcomingSalesPage from "@/pages/UpcomingSalesPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import EmploymentPage from "@/pages/EmploymentPage";
import EstateCleanoutsPage from "@/pages/EstateCleanoutsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  // GA4: send a page_view on every client-side route change (SPA)
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_title: document.title,
      });
    }
  }, [pathname]);
  // Pages also scroll via usePageMeta; this catches any edge cases.
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/estate-sales" element={<EstateSalesPage />} />
          <Route path="/services/cleanouts-downsizing" element={<CleanoutsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/service-areas/maryland" element={<MarylandPage />} />
          <Route path="/service-areas/northern-virginia" element={<NorthernVirginiaPage />} />
          <Route path="/upcoming-estate-sales" element={<UpcomingSalesPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/employment-opportunities" element={<EmploymentPage />} />
          <Route path="/estate-cleanouts" element={<EstateCleanoutsPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
